import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

/**
 * Botão (i) circular de metodologia — mesmo visual do trigger de
 * "Informações da rodada" do Flux (RoundInfoPopover), reduzido em 15%
 * (decisão de 10/08/2026). Estilo em Dashboard/index.scss.
 */
export default function InfoButton({ onClick, label }: { onClick: () => void; label: string }) {
  return (
    <button
      type="button"
      className="agro-overview-info-button"
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <FontAwesomeIcon icon={faInfo} />
    </button>
  );
}
